<template>
  <div>
    <click-to-edit
      v-model="value.permissions_profile_id"
      type="select"
      :disabled="disabled"
      placeholder=""
      select-filterable
      :select-options="profiles"
      select-option-id="id"
      select-option-name="name"
      select-cast-value-to-int
      @opened="loadProfiles"
      @input="changed"
    >
    </click-to-edit>
  </div>
</template>

<script>


import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "CascadingPermissionsProfileSelect",
  components: {ClickToEdit},
  props: {
    value: {}, // whole element
    disabled: {type: Boolean, default: false},
  },

  watch: {
    'value.permissions_profile': function (newVal) {
      this.profiles = [];
      if( this.value?.permissions_profile ){
        this.profiles.push(this.value?.permissions_profile);
      }
    },
    //
    // 'value.scale.template': function (newVal) {
    //   this.initQualityScaleSelect();
    // },
    // 'value.scale': function (newVal) {
    //   this.initQualityScaleSelect();
    // },
  },
  mounted() {
    if( this.value?.permissions_profile ){
      this.profiles.push(this.value?.permissions_profile);
    }

  },
  data() {
    return {
      profiles: [],
    }
  },
  computed: {},
  methods: {


    loadProfiles() {
      this.$api.cascading.getPermissionsProfiles({
        fields: 'id,name'
      })
        .then(data => {
          this.profiles = data.profiles;
        })
        .finally(() => {
          this.loading = false;
        })
    },


    changed() {
      this.$emit('input', this.value);
      this.$emit('change', this.value)
    }
  },

}
</script>


<style scoped>

</style>